import { Popover } from "driver.js";
import "driver.js/dist/driver.css";
import { folderSteps } from "./steps/folders";
import { goodbyeStep, helloStep } from "./steps/comments";
import { pointSteps } from "./steps/point";
import { controlsSteps } from "./steps/controls";
import { gallerySteps } from "./steps/gallery";
import { settingsSteps } from "./steps/settings";
import { baseGuide } from "./steps/baseGuide";

export type DriverStepConfig = {
    element: string;
    popover: Popover
    waitFor?: () => Promise<any>;
};

/**
 * Инициализируем тур
*/
export const initSteps = (): DriverStepConfig[] => {
    return [
        ...baseGuide
        // helloStep,
        // ...folderSteps,
        // ...pointSteps,
        // ...controlsSteps,
        // ...gallerySteps,
        // ...settingsSteps,
        // goodbyeStep
    ]
}